import { PaginatedResult } from 'Src/models/pageOpts';
import { coreService } from 'Src/network/AutomatedService';
import { definitions } from 'Src/vendor/posapi/pos';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const sectionId = 'payInOutService';

enum PayInOutType {
  PayIn = 'pay-in',
  PayOut = 'pay-out',
}

enum PayInPaymentMethod {
  Cash = 'cash',
  CardReader = 'card-reader',
  ManualCardEntry = 'manual-card-entry',
}

type PayInOutReason = definitions['types.PayInOutReason'];
type PayInOutTx = definitions['types.PayInOutTx'];
type PayInOutTxPayload = definitions['types.PayInOutTxRequest'];
type PayInOutGetAllReturn = PaginatedResult<PayInOutTx>;

const service = {
  payIn: coreService['POS:POST:Payment.PayIn'],
  payOut: coreService['POS:POST:Payment.PayOut'],
  void: coreService['POS:DELETE:Payment.PayInOut'],
  getAll: coreService['POS:GET:Payment.PayInOuts'],
  getAllReasons: coreService['POS:GET:PayInOutReasons'],
  payInManual: coreService['POS:POST:Payment.PayIn.Manual'],
};

export default service;
export type { PayInOutGetAllReturn, PayInOutReason, PayInOutTx, PayInOutTxPayload };
export { PayInOutType, PayInPaymentMethod };
